const awsmobile = {
  aws_project_region: "us-east-1",
  aws_appsync_region: "us-east-1",
  aws_appsync_graphqlEndpoint:
    "https://yijz5e7p3zgefa7mgt5t5tq7tm.appsync-api.us-east-1.amazonaws.com/graphql",
  aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
  aws_appsync_region: "us-east-1",
  aws_appsync_apiKey: "da2-oirpglgagvcjnpzykh62lqwgra",
  aws_cognito_identity_pool_id:
    "us-east-1:76bc3a6b-c6e8-4d44-848a-abf62fbd6e21",
  aws_user_pools_id: "us-east-1_opLJENqJZ",
  aws_cognito_region: "us-east-1",
  aws_user_pools_web_client_id: "et5el6r68n493gr5eo4cmcuq9",
  aws_cloud_logic_custom: [
    {
      name: "AdminQueries",
      endpoint: "https://pwbod06x4c.execute-api.us-east-1.amazonaws.com/admin",
      region: "us-east-1"
    }
  ],
  oauth: {},
  aws_user_files_s3_bucket: "pnp-merchant-storage-dev",
  aws_user_files_s3_bucket_region: "us-east-1"
};

export default awsmobile;
